"use client";

import createSvgIcon from "./utils/createSvgIcon.mjs";
import { jsx as _jsx } from "react/jsx-runtime";
export default createSvgIcon(/*#__PURE__*/_jsx("path", {
  d: "M19.73 14.23 7.71 2.21a.996.996 0 0 0-1.41 0L3.7 4.8c-.34.34-.39.88-.11 1.28l7.65 10.98c-.78.78-.78 2.05 0 2.83l1.41 1.41c.78.78 2.05.78 2.83 0l4.24-4.24c.79-.78.79-2.05.01-2.83m-5.66 5.65-1.41-1.41 4.24-4.24 1.41 1.41z"
}), 'CarpenterRounded');